<template>
<ItpBox
  direction="column"
  class="overflow-hidden h-100"
>
  <JobProgress
    :item="item"
  >
  </JobProgress>
  <ItpBox
    direction="row"
  >
    <ItpText
      muted
      :text="'Start time'|pgettext('Job')"
      class="mr-2"
      v-if="item.start_time"
    >
    </ItpText>
    <ItpText
      strong
      class="mr-4"
      v-if="item.start_time"
    >
      {{ item.start_time|datetime }}
    </ItpText>
    <ItpText
      muted
      :text="'End time'|pgettext('Job')"
      class="mr-2"
      v-if="item.end_time"
    >
    </ItpText>
    <ItpText
      strong
      class="mr-2"
      v-if="item.end_time"
    >
      {{ item.end_time|datetime }}
    </ItpText>
  </ItpBox>
  <ItpAlert
    show
    v-if="result_text && result_text != details"
  >
    <span>
      {{ result_text }}
    </span>
  </ItpAlert>
  <DIV
    class="border mt-2 overflow-auto"
    v-if="details"
  >
    <pre
      class="m-0 p-3 h-100 w-100"
      @click.stop="evh_6917646200545441_clickStop($event, {})"
    >{{ details }}</pre>
  </DIV>
  <JobFiles
    :item="item"
    v-if="item.files && item.files.length"
  >
  </JobFiles>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobRunView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onClick(...args: any[]) {
    const [ev] = args;
    const event = ev.originalEvent;

    if (event.detail === 3) {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(event.target);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get result_text() {
    if (this.loaded) {

      return (this.item.result_data && this.item.result_data.message) || this.item.result_text
    }
    return null;
  }

  get details() {
    if (this.loaded) {

      return (this.item.result_data && this.item.result_data.details) || this.item.log
    }
    return null;
  }

  async act_6917646200545441_script_7762_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6917646200545441_script_7762, alias=undefined
    this.onClick($event)
  }

  async act_6917646200545441_script_7762_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6917646200545441_script_7762, alias=undefined
    return {
      value: () => this.act_6917646200545441_script_7762_getActionArgs_value($event),
    }
  }

  async evh_6917646200545441_clickStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6917646200545441_clickStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_6917646200545441_script_7762: actions.ScriptAction;
    evh_6917646200545441_clickStop_7761: actions.EventHandlerImpl;
    evh_6917646200545441_clickStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_6917646200545441_script_7762 = new actions.ScriptAction(
      {
        actionArgs: this.act_6917646200545441_script_7762_getActionArgs,
        events: [],
      }
    );
    const evh_6917646200545441_clickStop_7761 = new actions.EventHandlerImpl(
      {
        action: act_6917646200545441_script_7762,
        event: "click.stop",
        displayName: "script",
      }
    );
    const evh_6917646200545441_clickStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6917646200545441_clickStop_7761],
      }
    );
    return {
      act_6917646200545441_script_7762,
      evh_6917646200545441_clickStop_7761,
      evh_6917646200545441_clickStop,
    }
  }
}

Vue.component("JobRunView", JobRunView);

</script>